import React, { useState, useEffect, useMemo } from "react";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// import {  Modal } from 'antd';
import FilterSelect from "components/Form/filterSelect";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm, Controller, useFieldArray } from 'react-hook-form';
import {customStyleSelect, formatDateHandler, formatDateHandler2, toTitleCase } from "utils/common";
import useUploadHook from "components/uploadHook";


import { Link } from "react-router-dom";

import {  toast, Bounce } from 'react-toastify';
import {format} from "date-fns"
import { Button } from "components/Button";
import { useSelector } from "react-redux";
import { leaveStatusOptions } from "utils/constants";
import EssFullWidthModal from "components/modelpopup/baseModal";
import { Steps } from 'antd';
import { FaCheckCircle } from "react-icons/fa";
import { MdPending } from "react-icons/md";
import { MdOutlineError } from "react-icons/md";
import { FaTimesCircle } from "react-icons/fa";
import Attachment from "components/Attachments/attachmentListEdit";
import Image from "components/Image";
import { useDropzone } from 'react-dropzone';
import { createAssetUser , getAssetUserDetailApi, statusChangeAssetApi, updateAssetUser} from "api/services/assets";
import DateInput from "components/Form/dateInput";



const EmployeeLeaveModelPopup = (props) => {
  const ApprovalSchema = Yup.object().shape({
    approval_status: Yup.object().required('Status is required'), 
    comment: Yup.string(), 

    // comments: Yup.string().test(
    //   'is-required-when-rejected',
    //   'Comments are required when the status is rejected',
    //   function (value) {
    //     const { approval_status } = this.parent; // Access the parent object
    //     return approval_status?.value !== 'rejected' || (value && value.trim().length > 0);
    //   }
    // ),
  
  });
   // Use Dropzone hook
 
  const [loading, setLoading] = useState(false);
  const [statusOptions, setStatusOptions] = useState([
    {value: "approved", label: "Approved"}, {value:"rejected", label: "Rejected"}, {value:"cancelled", label: "Cancelled"}
  ]);

  
  const [userOption, setUserOption] = useState([]);

  const [selectedUserAsset, setSelectedUserAsset] = useState("");

  const [currentStatusStep, setCurrentStatusStep] = useState(0);
  const [statusSteps, setStatusSteps] = useState([]);
  

  const assetUserSchema = Yup.object().shape({

    issue_date: Yup.date().required('Start date is required'), 
    // return_date: Yup.date().required('Return date is required').min(Yup.ref('issue_date'), 'Return date must be greater than issue date'), 
    //comment: Yup.string(),
    company_user: Yup.object().required('user is required'),
    current_value: Yup.string(),

    attachments: Yup.array()

  
  });


  const {
    uploadLoading,
    handleFile
  } = useUploadHook()
  const {

    userData, userDataLoading,
  
   
} = useSelector((state) => state.common);
const {
  user,
  userLoading
} = useSelector((state) => state.user);
  const {
    control,
    handleSubmit,
    formState: { errors },
    getValues,
    watch,
    setValue,
    setError,
    reset  ,
    register,
    trigger
  } = useForm({
    resolver: yupResolver(assetUserSchema), 
    defaultValues: {
      // company_user: userData.length===1 ? userData[0] : {}
    },
  });


  
  const {
    control: statusControl,
    handleSubmit: handleStatusSubmit,
    formState: { errors: statusError },
    setValue: setStatusValue,
    reset  : statusReset,
    setError: setStatusError
  } = useForm({
    resolver: yupResolver(ApprovalSchema), 
    defaultValues: {
      
    },
  });





  const { fields, append, prepend, remove, swap, move, insert } = useFieldArray({
    control, // control props comes from useForm (optional: if you are using FormProvider)
    name: "attachments", // unique name for your Field Array
    
  });


 

  useEffect(()=>{
    if(props?.selectedAssetUser?.id){
      console.log(props?.selectedAssetUser, "dataaa")

      getAssetUserDetailApi(props?.selectedAssetUser?.id).then(response=>{
        console.log(response.data, "dataaa")
        setSelectedUserAsset(response.data)
        createApprovalSteps(response.data)
        setValue("attachments", response.data?.attachments?.map(item=> {
          return {
            // id: item.id,
            item_id:item.id,
            url: item.url
          }
        }))

      })
    }
  },[props.selectedAssetUser, props.assetUserModal])
  

  const createApprovalSteps = (data) => {
    let generated_steps = []
    let current_step = data?.approval_level
    let existing_steps = data?.asset_approval
    
    // if(props?.selectedLeave?.approval_status == "cancelled"){
    //   generated_steps.push({
    //     title: 'Request',
    //     subTitle: "Cancelled",
    //     description:<span className="text-wrap lh-1" style={{fontSize:9}} >{`Requested on ${formatDateHandler2(props.selectedLeave?.created_at)} by ${props?.selectedLeave?.request_created_by?.first_name} ${props?.selectedLeave?.request_created_by?.last_name} ${props?.selectedLeave?.comment ? " | Comment : " + props?.selectedLeave?.comment : ""}`}</span>,
    //     icon: <FaTimesCircle  color="red" size={35} />
    //   })

    // }else{
    //   generated_steps.push({
    //     title: 'Request',
    //     subTitle: "Created",
    //     description:<span className="text-wrap lh-1" style={{fontSize:9}} >{`Requested on ${formatDateHandler2(props.selectedLeave?.created_at)}  by ${props?.selectedLeave?.request_created_by?.first_name} ${props?.selectedLeave?.request_created_by?.last_name} ${props?.selectedLeave?.comment ? " | Comment : " + props?.selectedLeave?.comment : ''}`}</span>,
    //     icon: <FaCheckCircle  color="green" size={35} />
    //   })
    // }
    existing_steps.forEach(item=> {
      generated_steps.push({
        title: 'Approval',
        subTitle: toTitleCase(item?.approval_status),
        description:<span className="text-wrap lh-1" style={{fontSize:9}} >{`${item?.approval_status=="pending"? item.approver?.first_name+" "+ item.approver?.last_name : toTitleCase(item.approval_status)+" on "+ formatDateHandler2(item?.approved_on) +" by "+item.approver?.first_name+" "+ item.approver?.last_name}  ${item?.comment ? "| Comment : " + item?.comment : ''}`}</span>,
        icon:item?.approval_status=="pending" ?<MdPending   size={35} /> : item?.approval_status=="rejected" ? <FaTimesCircle  color="red" size={35} /> : <FaCheckCircle  color="green" size={35} />
      })
    })
    setCurrentStatusStep(current_step)
    setStatusSteps(generated_steps)
    // let steps = [
    //   {
    //     title: 'Requested',
    //     description:'Requested on 12-12-2025',
    //     icon: <FaCheckCircle  color="green" size={35} />
    //   },
    //   {
    //     title: 'Approval',
    //     subTitle: 'Pending',
    //     description:'Manzeer MM',
    //     icon: <MdPending   size={35} />
    //   },
    //   {
    //     title: 'Approval',
    //     subTitle: 'Pending',
    //     description:'Arun A',
    //     icon: <MdPending   size={35} />

    //   },
    // ]
  }
  


  useEffect(()=>{
    if(props?.selectedAssetUser?.id){
      
      console.log(props.selectedAssetUser, "LLLLL")
      // setValue("attachments", props.selectedAssetUser?.attachments?.map(item=> {
      //   return {
      //     // id: item.id,
      //     item_id:item.id,
      //     url: item.url
      //   }
      // }))

      setValue("comment", props.selectedAssetUser?.comment||"")
    //   setValue("comment", props.selectedAssetUser?.comment||"")
    let company_user = userOption.find(item=> item.value == props?.selectedAssetUser?.company_user?.id)
    
    if(company_user){
        setValue("company_user", company_user)

    }
    setValue("issue_date", props.selectedAssetUser?.issue_date||"")
    // setValue("return_date", props.selectedAssetUser?.return_date||"")
    setValue("current_value", props.selectedAssetUser?.current_value)

   
      // let approvalStatus = leaveStatusOptions.find(item=> item.value == props.selectedAssetUser.approval_status)
      // console.log(approvalStatus, leaveStatusOptions,props.selectedAssetUser.approval_status, "JJJJ")
      // setValue("approval_status", approvalStatus)

    }else{
      // reset()
      reset({
        company_user: null,
        current_value: null,
        issue_date: null,
        comment: null,
        attachments: []
      })

      let selectedUserOption = userOption.find(item=> item.value == user?.id)
      if(selectedUserOption){
        console.log(selectedUserOption, "SELECTEDDDDDDDDD")
        setValue("company_user", selectedUserOption)
      }

    }
  }, [props.selectedAssetUser, props.assetUserModal, userOption])

  useEffect(()=>{

    console.log(userData, "KKK")
    if (userData && user) {
      let users = userData?.map(item => ({
        label: `${item.emp_no} - ${item.first_name} ${item.last_name}`,
        value: item.id
    }));
      setUserOption(users);
      
  }
  
 
  
  
  },[userData])

  

  
  const fileUploadHandler = async(acceptedFiles , rejectedFiles , e) => {
    console.log(e.target.files, "EEEE")
    let attachments = []
    const urls = await handleFile(e);
    if(Array.isArray(urls)){
       attachments = urls.map(item=>{return{url: item}})
    }else{
      attachments.push({
        url:urls
      })
    }
    console.log(fields, "LLLL")

    setValue("attachments", [...fields,...attachments])
   }

   const { getRootProps, getInputProps } = useDropzone({
    onDrop: fileUploadHandler,

    accept: 'image/*', // Accept image, PDF, DOCX
    disabled: user.id == selectedUserAsset?.current_approver?.id
  });

   const  onSubmit = (formData) =>{
    let data = {
      ...formData
    }
    data['asset'] = props?.selectedAsset?.id
    console.log(data, props?.selectedAsset, "LLLLL")
    setLoading(true)

    data['company_user'] = data?.company_user?.value

    let attachments_data = data.attachments?.map(item=>{
        return{
          id: item.item_id||"",
          url: item.url
        }
      })
      data['attachments'] = attachments_data

      

    if(data.issue_date){
      data['issue_date'] = format(new Date(data.issue_date), "yyyy-MM-dd")
    }
 

    if(props.selectedAssetUser?.id){
        updateAssetUserHandler(data)
    }
    else{
        createAssetUserHandler(data)
    }


  
    
    

   
  }

  const updateAssetUserHandler = (data) => {
    updateAssetUser(props.selectedAssetUser?.id, data).then(response=>{
        setLoading(false)

        toast.success('Asset user updated!', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
          });
          props.setAssetUserModal(false);
        
          props.getAssetList();
          // reset()
          reset({
            company_user: null,
            current_value: null,
            issue_date: null,
            comment: null,
            attachments: []
          })
  

        console.log(response, "REEEEEE")
      }).catch(e=> {
        setLoading(false)
        try{
          console.log(e.response.data, "EEEEE")
        if(e.response.data){
          Object.entries(e.response.data).forEach(([k, v]) => {
            console.log(typeof v, "EEEEE")
            setError(k,
              {
                type: 'manual',
                message: v.join(", ")
              }
               )
          })
        }
        }catch(err){
          let message = e.response?.data?.error || 'Failed to assign asset to user!'
          toast.error(message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
            });
        }
  
      })
  }

  const createAssetUserHandler = (data) => {
    createAssetUser(data).then(response=>{
        setLoading(false)
  
        toast.success('User Assigned!', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
          });
          props.setAssetUserModal(false);
        
          props.getAssetList();
          // reset()
          reset({
            company_user: null,
            current_value: null,
            issue_date: null,
            comment: null,
            attachments: []
          })
  
        console.log(response, "REEEEEE")
      }).catch(e=> {
        console.log(e, "eee")
        setLoading(false)
        try{
          console.log(e.response.data, "EEEEE")
        if(e.response.data){
          Object.entries(e.response.data).forEach(([k, v]) => {
            console.log(typeof v, "EEEEE")
            setError(k,
              {
                type: 'manual',
                message: v.join(", ")
              }
               )
          })
        }
        }catch(err){
          let message = e.response?.data?.error || 'Failed to assign asset to user!'
          toast.error(message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
            });
        }
  
        
      })

  }

  const company_user = watch("company_user")


  const onStatusChange = (payload) => {


    let data = {
      ...payload
    }
    setLoading(true)

    console.log(data, "LLLLL")
    data['approval_status'] = data?.approval_status?.value
    statusChangeAssetApi(selectedUserAsset?.id,data).then(response=>{

      toast.success('Asset status updated!', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
        });
        
        setLoading(false)

        props.setAssetUserModal(false);
          
        props.getAssetList();
        // reset()
        reset({
                  company_user: null,
                  current_value: null,
                  issue_date: null,
                  comment: null,
                  attachments: []
                })

        

      }).catch(e=> {
      console.log(e, "eee")
      try{
        console.log(e.response.data, "EEEEE")

        setLoading(false)
       
      if(e.response.data){
        Object.entries(e.response.data).forEach(([k, v]) => {
          console.log(typeof v,k, "EEEEE")
          setStatusError(k,
            {
              type: 'manual',
              message: v.join(", ")
            }
             )
        })
      }
      }catch(err){
        console.log(err, "LLLLLLL")
        let response = e.response?.data?.error || "Error updating leave status!"
        setLoading(false)
          toast.error(response, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
            });
        
      }



      
    })


   }
   

  return (
    <>

        <EssFullWidthModal
        mask={false}
              title={props.selectedAssetUser? "Update Asset User" :"Set Asset User"}
              // style={{ top: 100 }}
              open={props.assetUserModal}
              width={"40%"}
              footer={[]}     
              onCancel={() => {
                // reset()
                reset({
                  company_user: null,
                  current_value: null,
                  issue_date: null,
                  comment: null,
                  attachments: []
                })
                
                props?.setSelectedAssetUser("")
                props.setAssetUserModal(false)}}
                className="full-width-modal"


            >
              
          <div className="modal-content">
           
            <div className="modal-body">

              {/* {
                selectedUserAsset && (
                  <div className="col-md-12 col-sm-12" >
                  <div className="card p-3" >
                  <label className="col-form-label">
                    Approval status
                  </label>

                  <Steps
                  current={currentStatusStep}
                  // percent={60}
                  items={statusSteps}
                />
                  </div>
               
                </div>
                )
              } */}
             
              <form  onSubmit={handleSubmit(onSubmit)}>

                <div className="row" >
              <div className="input-block mb-3 col-md-6 col-sm-12">
                  <label className="col-form-label">
                    User <span className="text-danger">*</span>
                  </label>
                 
                  <Controller
                        name={`company_user`}
                        // name={"assignee"}
                        control={control}
                        // defaultValue=""
                        // rules={{ required: 'Select a contact' }}
                        render={({ field }) => (
                          <>
                            <FilterSelect 
                            // className={"w-50"}
                            isDisabled={userOption.length == 1 || props.selectedAssetUser?.id || (user.id == selectedUserAsset?.current_approver?.id)}
                            isClearable={true} 
                            onChange={(e) => {
                              field.onChange(e);
                            }}
                            optionLabel={"label"} 
                            optionValue={'value'} 
                            options={userOption}
                            defaultValue={userOption[0]}
                            value={field.value}
                              placeholder={"Select user"}
                              styles={customStyleSelect}
                              isLoading={userDataLoading}
                              />

                           
                          </>
                        )}
                      />
                      {errors.company_user && (
                        <small className="text-danger">
                          {errors.company_user?.message}
                        </small>
                      )}

                </div>

                <div className="input-block mb-3 col-md-6 col-sm-12">
                  <label className="col-form-label">
                    Current value
                  </label>
                  <input
                  {...register("current_value")}
                            // rows={4}
                            className="form-control"
                            disabled={(user.id == selectedUserAsset?.current_approver?.id)}
                            // value={field?.value}
                            // onChange={field?.onChange}
                            step="0.01"
                          />
                  {errors.current_value && (
                        <small className="text-danger">
                          {errors.current_value?.message}
                        </small>
                      )}
                </div>

                <div className="input-block mb-3 col-md-6 col-sm-12">
                  <label className="col-form-label">
                    Issue Date <span className="text-danger">*</span>
                  </label>
                  {/* <div className="cal-icon"> */}
                  <Controller
                          name="issue_date"
                          control={control}
                          // rules={{ required: 'File name is required' }}
                          render={({ field }) => (
                            <DateInput
                            disabled={(user.id == selectedUserAsset?.current_approver?.id)}
                                    className="form-control floating datetimepicker "
                                    selected={field?.value}
                                  onChange={(date) => field.onChange(date)}
                                    dateFormat="dd-MM-yyyy"
                                    // minDate={new Date()}

                                  
                                  />
                          
                          )}
                        />

                  {errors.issue_date && (
                        <small className="text-danger">
                          {errors.issue_date?.message}
                        </small>
                      )}
                   
                  {/* </div> */}
                </div>
                {/* <div className="input-block mb-3 col-md-6 col-sm-12">
                  <label className="col-form-label">
                    Return Date <span className="text-danger">*</span>
                  </label>
                  <Controller
                          name="return_date"
                          control={control}
                          // rules={{ required: 'File name is required' }}
                          render={({ field }) => (
                            <DateInput
                            DateInput={(user.id == selectedUserAsset?.current_approver?.id)}
                                    className="form-control floating datetimepicker "
                                    selected={field?.value}
                                  onChange={(date) => field.onChange(date)}
                                    dateFormat="dd-MM-yyyy"
                                    minDate={new Date()}
                                  
                                  />
                          
                          )}
                        />

                  {errors.return_date && (
                        <small className="text-danger">
                          {errors.return_date?.message}
                        </small>
                      )}
                   
                </div> */}
                <div className="input-block mb-3 col-md-6 col-sm-12">
                  <label className="col-form-label">
                    Comment 
                  </label>
                  <textarea
                  {...register("comment")}
                            rows={4}
                            className="form-control"
                            disabled={(user.id == selectedUserAsset?.current_approver?.id)}
                            // value={field?.value}
                            // onChange={field?.onChange}
                          />
                  {/* <Controller
                          name="comment"
                          control={control}
                          // rules={{ required: 'File name is required' }}
                          render={({ field }) => (
                           
                          
                          )}
                        /> */}
                 
                </div>
             
                </div>
                 
             

             
                <div className="row" >
                
              
              
              
                </div>

                <div className="row" >

             
                </div>






                <div className="row">
                  <div className="col-md-6 col-sm-12">
                  <div className="input-block mb-3">

                  <label className="col-form-label">Attachments {
                    uploadLoading && <i class="fa fa-spinner fa-spin" ></i>
                  }</label>
                  <div
                      {...getRootProps({ className: 'dropzone' })}
                      style={{
                        border: '2px dashed #000',
                        padding: '20px',
                        textAlign: 'center',
                      }}
                    >
                      <input {...getInputProps()} />
                      <p>Drag & Drop your files here, or click to select files</p>
                    </div>

               


                  </div>

                  
                </div>
                </div>

                <div className="col-12" >
                <Attachment fields={fields} remove={remove}  />

                </div>


                <div className="submit-section">
                <Button
                  loading={loading}
                  disabled={loading || uploadLoading || (user.id == selectedUserAsset?.current_approver?.id)}
                    className="btn btn-primary submit-btn"             
                    type="submit"
                    label={selectedUserAsset?.id ? "Update":"Assign"}
                  />
                </div>
              </form>
             
              

              {
               (user.id == selectedUserAsset?.current_approver?.id) &&
               (
                <form  onSubmit={handleStatusSubmit(onStatusChange)} >
                
                <div className="col-md-6 col-sm-12" >
                <label className="col-form-label">
                    Change Status <span className="text-danger">*</span>
                  </label>
                  <Controller
                        name={`approval_status`}
                        // name={"assignee"}
                        control={statusControl}
                        // defaultValue=""
                        // rules={{ required: 'Select a contact' }}
                        render={({ field }) => (
                          <>
                            <FilterSelect 
                            isDisabled={statusOptions.length == 0}
                            isClearable={true} 
                            onChange={(e) => {
                              field.onChange(e);
                            }}
                            optionLabel={"label"} 
                            optionValue={'value'} 
                            options={statusOptions}
                            value={field.value}
                              placeholder={"Change Status"}
                              styles={customStyleSelect}
                              isLoading={false}
                              />

                           
                          </>
                        )}
                      />
                      {statusError.approval_status && (
                        <small className="text-danger">
                          {statusError.approval_status?.message}
                        </small>
                      )}
                      <br/>

                <label className="col-form-label ">
                    Comment 
                  </label>
                  <Controller
                          name="comment"
                          control={statusControl}
                          // rules={{ required: 'File name is required' }}
                          render={({ field }) => (
                            <textarea
                            disabled={statusOptions.length == 0}
                            rows={4}
                            className="form-control"
                            value={field?.value}
                            onChange={field?.onChange}
                          />
                          
                          )}
                        />
                  {statusError.comment && (
                        <small className="text-danger">
                          {statusError.comment?.message}
                        </small>
                      )}

                </div>
             
                <div className="submit-section">
                <Button
                  loading={loading}
                  disabled={loading }
                    className="btn btn-primary submit-btn"             
                    type="submit"
                    label="Change status"
                  />
                </div>
              </form>
               )
              }
              
            </div>
          </div>
    </EssFullWidthModal>

    </>
  );
};

export default EmployeeLeaveModelPopup;
